export const VITAL_LIMITS = {

  maxAge: 100,

  heightFt: { min: 1, max: 8 },

  heightIn: { min: 0, max: 11 },

  heightCm: { min: 50, max: 272 },

  weightLbs: { min: 50, max: 650 },

  weightKg: { min: 20, max: 300 },

  bpSys: { min: 70, max: 220 },

  bpDia: { min: 40, max: 130 },

};



export const todayYmd = () => {

  const d = new Date();

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

};



export const calcAge = (dob) => {

  if (!dob) return null;

  const birth = new Date(dob + "T00:00:00");

  if (Number.isNaN(birth.getTime())) return null;

  const today = new Date();

  let age = today.getFullYear() - birth.getFullYear();

  const m = today.getMonth() - birth.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;

  return age;

};



export const preventWheelChange = (e) => e.currentTarget.blur();



const clampNum = (val, min, max) => {

  if (val === "" || val == null) return "";

  const n = parseFloat(val);

  if (Number.isNaN(n)) return "";

  return String(Math.min(max, Math.max(min, n)));

};



const clampMaxOnly = (val, max) => {

  if (val === "" || val == null) return "";

  const n = parseFloat(val);

  if (Number.isNaN(n)) return "";

  return n > max ? String(max) : val;

};



export const clampPersonalField = (name, value, unit = "imperial") => {

  if (value === "") return "";

  switch (name) {

    case "heightFt":

      return clampNum(value, VITAL_LIMITS.heightFt.min, VITAL_LIMITS.heightFt.max);

    case "heightIn":

      return clampNum(value, VITAL_LIMITS.heightIn.min, VITAL_LIMITS.heightIn.max);

    case "heightCm":

      return clampNum(value, VITAL_LIMITS.heightCm.min, VITAL_LIMITS.heightCm.max);

    case "weight":

      return unit === "metric"

        ? clampMaxOnly(value, VITAL_LIMITS.weightKg.max)

        : clampMaxOnly(value, VITAL_LIMITS.weightLbs.max);

    case "bpSys":

      return clampMaxOnly(value, VITAL_LIMITS.bpSys.max);

    case "bpDia":

      return clampMaxOnly(value, VITAL_LIMITS.bpDia.max);

    default:

      return value;

  }

};



export function validatePersonalInfo(info) {

  const errors = {};



  if (!info.sex) errors.sex = "Please select biological sex.";



  if (!info.dob) {

    errors.dob = "Date of birth is required.";

  } else {

    const birth = new Date(info.dob + "T00:00:00");

    const today = new Date();

    today.setHours(0, 0, 0, 0);

    if (Number.isNaN(birth.getTime()) || birth >= today) {

      errors.dob = "Date of birth must be before today.";

    } else {

      const age = calcAge(info.dob);

      if (age != null && age > VITAL_LIMITS.maxAge) {

        errors.dob = `Age cannot exceed ${VITAL_LIMITS.maxAge} years.`;

      }

    }

  }



  if (info.unit === "metric") {

    const cm = parseFloat(info.heightCm);

    if (!cm || cm < VITAL_LIMITS.heightCm.min || cm > VITAL_LIMITS.heightCm.max) {

      errors.height = `Height must be ${VITAL_LIMITS.heightCm.min}–${VITAL_LIMITS.heightCm.max} cm.`;

    }

  } else {

    const ft = parseFloat(info.heightFt);

    const inches = parseFloat(info.heightIn) || 0;

    if ((!ft && !inches) || ft < VITAL_LIMITS.heightFt.min || ft > VITAL_LIMITS.heightFt.max) {

      errors.height = `Height must be ${VITAL_LIMITS.heightFt.min}–${VITAL_LIMITS.heightFt.max} ft.`;

    } else if (inches < VITAL_LIMITS.heightIn.min || inches > VITAL_LIMITS.heightIn.max) {

      errors.height = `Inches must be ${VITAL_LIMITS.heightIn.min}–${VITAL_LIMITS.heightIn.max}.`;

    }

  }



  const weight = parseFloat(info.weight);

  if (info.unit === "metric") {

    if (!weight || weight < VITAL_LIMITS.weightKg.min || weight > VITAL_LIMITS.weightKg.max) {

      errors.weight = `Weight must be ${VITAL_LIMITS.weightKg.min}–${VITAL_LIMITS.weightKg.max} kg.`;

    }

  } else if (!weight || weight < VITAL_LIMITS.weightLbs.min || weight > VITAL_LIMITS.weightLbs.max) {

    errors.weight = `Weight must be ${VITAL_LIMITS.weightLbs.min}–${VITAL_LIMITS.weightLbs.max} lbs.`;

  }



  const sys = parseFloat(info.bpSys);

  const dia = parseFloat(info.bpDia);



  if (!info.bpSys) {

    errors.bpSys = "Systolic is required.";

  } else if (Number.isNaN(sys) || sys < VITAL_LIMITS.bpSys.min || sys > VITAL_LIMITS.bpSys.max) {

    errors.bpSys = `Systolic must be ${VITAL_LIMITS.bpSys.min}–${VITAL_LIMITS.bpSys.max} mmHg.`;

  }



  if (!info.bpDia) {

    errors.bpDia = "Diastolic is required.";

  } else if (Number.isNaN(dia) || dia < VITAL_LIMITS.bpDia.min || dia > VITAL_LIMITS.bpDia.max) {

    errors.bpDia = `Diastolic must be ${VITAL_LIMITS.bpDia.min}–${VITAL_LIMITS.bpDia.max} mmHg.`;

  }



  if (

    info.bpSys &&

    info.bpDia &&

    !errors.bpSys &&

    !errors.bpDia &&

    !Number.isNaN(sys) &&

    !Number.isNaN(dia) &&

    dia >= sys

  ) {

    errors.bp = "Diastolic must be lower than systolic.";

  }



  return { valid: Object.keys(errors).length === 0, errors };

}

